import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-flip-card" }
const _hoisted_2 = {
  class: "gfu-flip-card__side gfu-flip-card__side--face",
  "data-qa": "card-face"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass($options.flipCardInnerClasses)
    }, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "face")
      ]),
      _createElementVNode("div", {
        class: _normalizeClass($options.flipCardBackClasses),
        "data-qa": "card-reverse"
      }, [
        _renderSlot(_ctx.$slots, "reverse")
      ], 2 /* CLASS */)
    ], 2 /* CLASS */)
  ]))
}